import { useState } from 'react';
import { API_URL } from '../constants';

const AUTH_KEY = 'convolines_admin_auth';

// Every admin screen sits behind the same HTTP Basic token, kept for the tab only.
export function useAdminToken() {
  return useState(() => sessionStorage.getItem(AUTH_KEY));
}

export function storeToken(token) {
  sessionStorage.setItem(AUTH_KEY, token);
}

export function adminFetch(token, path, options = {}) {
  return fetch(`${API_URL}${path}`, {
    ...options,
    headers: {
      ...options.headers,
      Authorization: `Basic ${token}`,
    },
  });
}

export { AUTH_KEY };
